
import React from "react";

import CleanUpTable from "../component/CleanUpTable";

const CleanUpTableContainer = () => (<CleanUpTable />)

export default CleanUpTableContainer; 